module.exports = __webpack_public_path__ + "static/media/bg_17.086c937a.png";